import React from "react";
import { Penalties } from "../../components/Penalty";

class PenaltyScreen extends React.Component {
  render() {
    return (
      <div>
        <Penalties
          apps={this.props.apps}
          token={this.props.ztoken}
          role={this.props.role}
          user_id={this.props.user_id}
          type="savings"
        />
      </div>
    );
  }
}

export default PenaltyScreen;
